/* eslint-disable no-nested-ternary */
import styled from 'styled-components'
import Link from 'next/link'
import { SecondaryButton } from 'common/button'
import { Typography } from 'common/typography'
import Divider from 'common/divider'
import { useCreateCourseEnrolment } from 'mutations/course'
import useSession from 'querys/session'
import { sendToDataLayer } from 'utils/push-to-datalayer'
import { fbqEvent } from 'utils/fbq'

const FreeCourseCardStyled = styled.div`
  h3 {
    text-align: left;
    margin: 0 auto;
  }
  @media (min-width: 768px) {
    h3 {
      text-align: center;
    }
  }
  @media (min-width: 1024px) {
    h3 {
      max-width: 350px;
    }
  }
`

function FreeCourseCard({ slug, hasCourseAccess }) {
  const enrolmentMutation = useCreateCourseEnrolment(slug)
  const { mutate, isSuccess } = enrolmentMutation
  const { token } = useSession()

  const createEnrolment = (e) => {
    fbqEvent({ event: 'create_free_enrollment' })
    sendToDataLayer({
      event: 'create_free_enrollment',
      cta_id: e.target.id,
    })
    mutate()
  }

  if (isSuccess) {
    return (
      <FreeCourseCardStyled>
        <Typography as="h3" font="headline5" align="center" color="var(--baseNeutral)">
          ¡Felicidades! Ya tienes acceso al curso.
        </Typography>
        <Divider marginBottom={16} marginVertical={0} marginHorizontal={0} color="transparent" />
      </FreeCourseCardStyled>
    )
  }

  if (hasCourseAccess && !isSuccess) return null

  return (
    <FreeCourseCardStyled>
      <Divider marginBottom={16} marginVertical={0} marginHorizontal={0} color="transparent" />
      {token ? (
        <SecondaryButton
          id="create_enrollment_from_landing"
          responsive
          padding={16}
          fullWidth
          fontWeight="500"
          onClick={(e) => createEnrolment(e)}
        >
          Unirme al curso
        </SecondaryButton>
      ) : (
        <Link href={`/login?next=/cursos/${slug}?is_free=true`} prefetch={false} passHref>
          <SecondaryButton
            padding={16}
            fullWidth
            fontWeight="500"
            responsive
            id="login_from_free_course_card"
          >
            Iniciar este curso
          </SecondaryButton>
        </Link>
      )}
    </FreeCourseCardStyled>
  )
}

export default FreeCourseCard
